import { Facet } from '@codemirror/state';

/**
 * @type {Facet<import('..').Variables>} Variables
 */
export const variablesFacet = Facet.define();
